let isProduce = false
let home = {
  // 轮播图的url
  banners: [{
    url: isProduce ? require("../assets/images/literacy_eles_banner.dark.png") : 'http://static.eaydu.com/imgs/home/home_banner_1.dark.png',
    name: "轻松场景",
    link: 'http://bj.jiajiaoban.cn/pc/ketpet/index.html',
  },
  {
    url: isProduce ? require("../assets/images/literacy_eles_banner.light.png") : 'http://static.eaydu.com/imgs/home/home_banner_2.dark.png',
    name: "金币激励",
    link: 'https://lecture.xueersi.com/pc/seriesList/801?m_channel=ad&monitor_type=ad&mevent_id=7942&monitor_id=51653&ad_id=7942'
  },
  {
    url: isProduce ? require("../assets/images/literacy_eles_banner.dark.png") : 'http://static.eaydu.com/imgs/home/home_banner_3.dark.png',
    name: "原创教辅"
  },
    // {
    //   url: isProduce ? require("../assets/images/literacy_eles_banner.light.png") : 'http://static.eaydu.com/imgs/home/home_banner_2.light.png',
    //   name: "课堂报告"
    // }
  ],
  // 热门推荐
  hot_recommads: [
    {
      // url: "../assets/hot_eses_banner2x.dark.png",
      url: isProduce ? require("../assets/images/home_recom_gold.png") : 'http://static.eaydu.com/imgs/home/home_recom_relaxed.png',
      name: "励步英语在家上",
      mp4: true,
      homeIndex: 5,
      type: 2
    },
    {
      url: isProduce ? require("../assets/images/home_recom_original.png") : 'http://static.eaydu.com/imgs/home/home_recom_gold.png',
      name: "格莱玛语法之代词",
      mp4: true,
      homeIndex: 6,
      type: 2
    },
    {
      url: isProduce ? require("../assets/images/home_recom_presentation.png") : 'http://static.eaydu.com/imgs/home/home_recom_original.png',
      name: "家长力学院",
      link: 'https://www.xueersi.com/course-detail/83682?m_channel=ad&monitor_type=ad&mevent_id=7395&monitor_id=51189&ad_id=7395'
    },
    {
      url: isProduce ? require("../assets/images/home_recom_relaxed.png") : 'http://static.eaydu.com/imgs/home/home_recom_presentation.png',
      name: "八大启蒙魔术",
      dataType: 'hot_recommads_side',
      dataindex: 2
    }
  ],
  // 名师视频课
  videos: [
    {
      name: "名师视频克",
      path: "http://eaydu-video.oss-cn-beijing.aliyuncs.com/mp4/videos/home/home_famous_teacher1.vertical.mp4",
      controls: true,
      ishide: false,
      image: isProduce ? require("../assets/images/video_img1.png") : 'http://static.eaydu.com/imgs/home/home_famous_teacher1.png'
    },
    {
      name: "名师视频克",
      path: "http://eaydu-video.oss-cn-beijing.aliyuncs.com/mp4/videos/home/home_famous_teacher2.vertical.mp4",
      controls: true,
      ishide: false,
      image: isProduce ? require("../assets/images/video_img2.png") : 'http://static.eaydu.com/imgs/home/home_famous_teacher2.png'
    },
    {
      name: "名师视频克",
      controls: true,
      ishide: false,
      path: "http://eaydu-video.oss-cn-beijing.aliyuncs.com/mp4/videos/home/home_famous_teacher3.transverse.mp4",
      image: isProduce ? require("../assets/images/video_img3.png") : 'http://static.eaydu.com/imgs/home/home_famous_teacher3.png'
    },
    {
      name: "名师视频克",
      controls: true,
      ishide: false,
      path: "http://eaydu-video.oss-cn-beijing.aliyuncs.com/mp4/videos/home/home_famous_teacher4.transverse.mp4",
      image: isProduce ? require("../assets/images/video_img4.png") : 'http://static.eaydu.com/imgs/home/home_famous_teacher4.png'
    },
    {
      name: "名师视频克",
      controls: true,
      ishide: false,
      path: "http://eaydu-video.oss-cn-beijing.aliyuncs.com/mp4/videos/home/home_famous_teacher5.transverse.mp4",
      image: isProduce ? require("../assets/images/video_img5.png") : 'http://static.eaydu.com/imgs/home/home_famous_teacher5.png'
    },
    {
      name: "名师视频克",
      controls: true,
      ishide: true,
      path: "http://eaydu-video.oss-cn-beijing.aliyuncs.com/mp4/videos/home/home_famous_teacher6.transverse.mp4",
      image: isProduce ? require("../assets/images/video_img5.png") : 'http://static.eaydu.com/imgs/home/home_famous_teacher5.png'
    },
    {
      name: "名师视频克",
      controls: true,
      ishide: true,
      path: "http://eaydu-video.oss-cn-beijing.aliyuncs.com/mp4/videos/home/home_famous_teacher7.transverse.mp4",
      image: isProduce ? require("../assets/images/video_img5.png") : 'http://static.eaydu.com/imgs/home/home_famous_teacher5.png'
    },
  ],
  // 名师精品课
  famous_good: [
    {
      url: isProduce ? require("../assets/images/teacher-second.png") : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher1.png',
      baseinfo: "尹辰（Eason）",
      intro:
        "6年教龄, 总结了一套系统的教学体系，对国内中考和MSE有深入研究课堂气氛活跃，让孩子摆脱沉闷的传统教学方式",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_famous_Videos1.mp4',
      controls: true,
      names: '尹辰（Eason）',
      time: '暂无',
      title: '暂无',
      price: 0,
      course: '暂无',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher_hight1.png',
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '对英语的热忱,跨越种族和时空',
    },
    {
      url: isProduce ? require("../assets/images/teacher-second.png") : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher2.png',
      baseinfo: "杨萌",
      intro:
        "7年教龄，高级教师，网校著名激情派老师学而思网校物理产品负责人初中物理课程体系设计者",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_famous_Videos2.mp4',
      controls: true,
      names: '杨萌',
      time: '5月20日 8:00',
      title: '如何把物理变成你的优势学科',
      price: 0,
      course: '物理',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher_hight2.png',
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '对英语的热忱,跨越种族和时空',
    },
    {
      url: isProduce ? require("../assets/images/teacher-second.png") : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher3.png',
      baseinfo: "刘飞飞",
      intro:
        "19年教龄，北大毕业语言怪才，大师授课，好评如潮",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_famous_Videos3.mp4',
      controls: true,
      names: '刘飞飞',
      time: '暂无',
      title: '暂无',
      price: 0,
      course: '暂无',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher_hight3.png',
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '对英语的热忱,跨越种族和时空',
      isjump: true,
      link: 'https://www.xueersi.com/t/liufeifei'
    }
  ],
  // 素养课
  literacyArr: [
    {
      src: isProduce ? require("../assets/images/literacy_eles_banner1.png") : 'http://static.eaydu.com/imgs/home/home_Accom_course1.png',
      title: "讲给孩子的《三字经》",
      sub_titles: "一学就懂的国学经典大师课",
      nums: 5868,
      price: 99,
      names: '钱文忠',
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_Accom_Videos1.mp4',
      controls: true,
      time: '暂无',
      course: '暂无'
    },
    {
      src: isProduce ? require("../assets/images/literacy_eles_banner1.png") : 'http://static.eaydu.com/imgs/home/home_Accom_course2.png',
      title: "3节课读透世界名著",
      sub_titles: "读透老人与海 理解核心硬汉精神",
      nums: 4818,
      price: 39,
      names: '李煜晖',
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_Accom_Videos2.mp4',
      controls: true,
      time: '暂无',
      course: '暂无'
    },
    {
      src: isProduce ? require("../assets/images/literacy_eles_banner1.png") : 'http://static.eaydu.com/imgs/home/home_Accom_course3.png',
      title: "不可不知的大唐盛世",
      sub_titles: "跟随于老师10堂课带孩子全面了解唐朝",
      nums: 2568,
      price: 99,
      names: '于庚哲',
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_Accom_Videos3.mp4',
      controls: true,
      time: '暂无',
      course: '暂无'
    },
    {
      src: isProduce ? require("../assets/images/literacy_eles_banner1.png") : 'http://static.eaydu.com/imgs/home/home_Accom_course4.png',
      title: "诗词可以这样学",
      sub_titles: "跟着诗词逛名胜 变身文化小达人",
      nums: 3571,
      price: 99,
      names: '程遂营',
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_Accom_Videos4.mp4',
      controls: true,
      time: '暂无',
      course: '暂无'
    }
  ],
  // 0元课
  freeArr: [
    {
      title: "小学英语毕业考提升密训营—必考题型大揭秘",
      time: "4月12日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto1.png',
      names: "荆 楠",
      nums: 1587,
      course: "英语",
      // mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos1.mp4',
        mp4: isProduce ? '' : 'http://static.eaydu.com/vod/GettyImages-905229768.mov',
      controls: true,
      price: 0,
      relateCourse: [
        {
          name: '【暑】六年级升初一英语直播勤学班（全国版）',
          teacher: "荆 楠",
          time: '8月3日-8月13日·每天13:00上课',
          link: 'https://www.xueersi.com/course-detail/78809/561904?switch_grade=-1&switch_subject=3'
        },
        {
          name: '上海小初衔接必修课（英语1期)',
          teacher: "荆 楠",
          time: '5月31日-6月4日每天19:00-20:30',
          link: 'https://www.xueersi.com/course-detail/84348/662510?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【暑】五年级升预初英语直播目标班（沪教版）',
          time: '8月3日-8月13日·每天18:50上课',
          teacher: "荆 楠",
          link: 'https://www.xueersi.com/course-detail/78828/561918?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【暑】六年级升初一英语直播勤学班（全国版）',
          time: '8月18日-8月28日·每天18:50上课',
          teacher: "荆 楠",
          link: 'https://www.xueersi.com/course-detail/78806/561898?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【春下】初二英语直播勤学班（上海沪教）',
          time: '每周六09:00-11:10·6月20日结课',
          teacher: "荆 楠",
          link: 'https://www.xueersi.com/course-detail/73497/352768?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【春下】初二英语直播勤学班（上海沪教）',
          time: '每周六09:00-11:10·6月20日结课',
          teacher: "荆 楠",
          link: 'https://www.xueersi.com/course-detail/73497/352768?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【暑】初二升初三英语直播菁英班（沪教版）',
          time: '8月1日-8月15日·每天09:00上课',
          teacher: "荆 楠",
          link: 'https://www.xueersi.com/course-detail/78819/520983?switch_grade=-1&switch_subject=3'
        },
      ],
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '对英语的热忱,跨越种族和时空',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high1.png'
    },
    {
      title: "妙笔生花-从《茶馆》学人物语言描写",
      time: "4月25日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto2.png',
      names: "齐君颜",
      nums: 1817,
      course: "语文",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos2.mp4',
      controls: true,
      price: 0,

      relateCourse: [
        {
          name: '【暑】六年级升初一语文阅读写作直播班',
          time: '8月18日-8月28日每天18:50',
          teacher: '齐君颜',
          link: 'https://www.xueersi.com/course-detail/79929/562004?switch_grade=-1&switch_subject=1'
        },
        {
          name: '【暑】六年级升初一语文阅读写作直播班',
          time: '8月3日-8月13日每天18:50',
          teacher: '齐君颜',
          link: 'https://www.xueersi.com/course-detail/79938/562022?switch_grade=-1&switch_subject=1'
        },
        {
          name: '【暑】六年级升初一语文阅读写作直播班',
          time: '8月3日-8月13日每天09:00',
          teacher: '齐君颜',
          link: 'https://www.xueersi.com/course-detail/79937/562020?switch_grade=-1&switch_subject=1'
        }
      ],
      upgrade: '四川大学',
      degree: '艺术学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '诗情画意，领略语文之美； <br/> 刷题能手，把握命题方向； <br/>  缜密逻辑，攻克阅读难题； <br/>  发散思维，享受写作乐趣；<br/>',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high2.png'

    },
    {
      title: "一节课突破六年级英语必考易错题",
      time: "4月23日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto3.png',
      names: "林芝卉",
      nums: 742,
      course: "英语",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos3.mp4',
      controls: true,
      price: 0,
      relateCourse: [
        {
          name: '【暑】六年级升初一英语直播目标班（全国版）',
          time: '8月3日-8月13日·每天09:00',
          teacher: '林芝卉',
          link: 'https://www.xueersi.com/course-detail/78858/561946?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【暑】六年级升初一英语直播目标班（全国版）',
          time: '8月3日-8月13日·每天13:00',
          teacher: '林芝卉',
          link: 'https://www.xueersi.com/course-detail/78857/561944?switch_grade=-1&switch_subject=3'
        }
      ],
      upgrade: '知名教育机构项目负责人',
      degree: '优秀培训师，特聘讲师',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '抓住规律，触类旁通；串联知识，事半功倍',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high3.png'
    },
    {
      title: "勤学篇—凿壁借光，闻鸡起舞",
      time: "5月1日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto4.png',
      names: "关 艺",
      nums: 1478,
      course: "语文",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos4.mp4',
      controls: true,
      price: 0,
      relateCourse: [
        {
          name: '【暑】小班数学思维直播班',
          time: '6月29日-9月10日·每周一、周四19:30',
          teacher: '范珈彤',
          link: 'https://www.xueersi.com/course-detail/80130/599059?switch_grade=-1&switch_subject=59'
        },
        {
          name: '【暑】大班语文思维直播班',
          time: '7月1日-9月12日·每周三19:00-19:50',
          teacher: '王 越',
          link: 'https://www.xueersi.com/course-detail/76906/481647?switch_grade=-1&switch_subject=1'
        },
        {
          name: '【目标130+】高三英语暑假一轮复习（上）直播班',
          time: '8月5日-8月17日·每天19:00',
          teacher: '吴俊东',
          link: 'https://www.xueersi.com/course-detail/79320/608013?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【目标省一】高一数学竞赛暑假直播班（一试）',
          time: '7月22日-8月4日·每天12:30',
          teacher: '苏宇坚',
          link: 'https://www.xueersi.com/course-detail/79350/521832?switch_grade=-1&switch_subject=2'
        }
      ],
      upgrade: '南京大学',
      degree: '硕士研究生',
      experience: '10年',
      style: '专注于低年级语文数学',
      idea: '抓住规律，触类旁通；串联知识，事半功倍',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high4.png'
    },
    {
      title: "2019中考数学真题重难点解析",
      time: "5月1日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto5.png',
      names: "文 博",
      nums: 2669,
      course: "数学",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos5.mp4',
      controls: true,
      price: 0,
      relateCourse: [
        {
          name: '【春下目标清北班】高二数学直播班（上海）',
          time: '每周六18:30-20:45·6月20日结课',
          teacher: '文 博',
          link: 'https://www.xueersi.com/course-detail/73054/349329?switch_grade=-1&switch_subject=2'
        },
        {
          name: '【目标双一流】高一数学暑假班（上海)',
          time: '8月5日-8月11日·每天13:30',
          teacher: '文 博',
          link: 'https://www.xueersi.com/course-detail/82619/608867?switch_grade=-1&switch_subject=2'
        },
        {
          name: '【春下目标985班】高二数学直播班（上海）',
          time: '每周日07:30-09:45·6月21日',
          teacher: '文 博',
          link: 'https://www.xueersi.com/course-detail/73056/349369?switch_grade=-1&switch_subject=2'
        },
        {
          name: '【目标140+】高三数学暑假一轮复习（上）直播班（上海）',
          time: '8月5日-8月24日·每天19:00',
          teacher: '文 博',
          link: 'https://www.xueersi.com/course-detail/83059/610905?switch_grade=-1&switch_subject=2'
        },
      ],
      upgrade: '清华大学',
      degree: '美国范德堡大学数学系博士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '高一：思考力——看到什么，想到什么，做了什么；<br/>高二：学习力——学习学习的方法；<br/>高三：专注力与意志力——正确的坚持；<br/>使命：文博留给你的不止是数学，还有人生品格；<br/>',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high5.png'
    },
    {
      title: "中考物理压轴专题—电学篇",
      time: "5月2日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto6.png',
      names: "于鲲鹏",
      nums: 1679,
      course: "物理",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos6.mp4',
      controls: true,
      price: 0,
      relateCourse: [
        {
          name: '【春下目标自招综评班】高一物理直播班',
          time: '每周六15:15-17:30·6月20日结课',
          teacher: '于鲲鹏',
          link: 'https://www.xueersi.com/course-detail/73301/482485?switch_grade=-1&switch_subject=4'
        },
        {
          name: '中考物理实验专题冲刺',
          time: '5月17日-24日每周日',
          teacher: '于鲲鹏',
          link: 'https://www.xueersi.com/course-detail/84189/650962?switch_grade=-1&switch_subject=4'
        },
        {
          name: '【目标强基计划】高二物理暑假直播班',
          time: '8月5日-8月17日·每天10:30',
          teacher: '于鲲鹏',
          link: 'https://www.xueersi.com/course-detail/79363/521875?switch_grade=-1&switch_subject=4'
        },
        {
          name: '【春】高一物理综评习题课——五星学霸养成指南',
          time: '5月16日-6月20日每周六21:00-22:00',
          teacher: '于鲲鹏',
          link: 'https://www.xueersi.com/course-detail/77657/496271?switch_grade=-1&switch_subject=4'
        },
        {
          name: '【春下目标自招综评班】高一物理直播班',
          time: '每周日13:30-15:45·6月21日结课',
          teacher: '于鲲鹏',
          link: 'https://www.xueersi.com/course-detail/73302/351621?switch_grade=-1&switch_subject=4'
        },
        {
          name: '【春下目标自招综评班】高一物理直播班',
          time: '每周六15:15-17:30·6月20日结课',
          teacher: '于鲲鹏',
          link: 'https://www.xueersi.com/course-detail/73301/482485?switch_grade=-1&switch_subject=4'
        }
      ],
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '教师要做的不仅是知识的讲授，更重要的是让学生学会思考，进行真正地学习',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high6.png'
    }
  ],
  hot_recommads_side: [
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom1.png',
      title: "如何把物理变成你的优势学科",
      intros: "如何把物理变成你的优势学科",
      price: 0,
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay1.mp4',
      controls: true,
      course: '推荐',
      time: '暂无',
      names: '杨萌',
    },
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom2.png',
      title: "茶馆，东方舞台上的奇迹",
      intros: "茶馆，东方舞台上的奇迹",
      price: 0,
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay2.mp4',
      controls: true,
      course: '推荐',
      time: '暂无',
      names: '齐君颜',
      relateCourse: [
        {
          name: '【暑】六年级升初一语文阅读写作直播班',
          time: '8月18日-8月28日每天18:50',
          teacher: '齐君颜',
          link: 'https://www.xueersi.com/course-detail/79929/562004?switch_grade=-1&switch_subject=1'
        },
        {
          name: '【暑】六年级升初一语文阅读写作直播班',
          time: '8月3日-8月13日每天18:50',
          teacher: '齐君颜',
          link: 'https://www.xueersi.com/course-detail/79938/562022?switch_grade=-1&switch_subject=1'
        },
        {
          name: '【暑】六年级升初一语文阅读写作直播班',
          time: '8月3日-8月13日每天09:00',
          teacher: '齐君颜',
          link: 'https://www.xueersi.com/course-detail/79937/562020?switch_grade=-1&switch_subject=1'
        }
      ],
    },
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom3.png',
      title: "如何把物理变成你的优势学科",
      intros: "如何把物理变成你的优势学科",
      price: 0,
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay3.mp4',
      controls: true,
      course: '推荐',
      time: '8月18日',
      names: '段超',
      relateCourse: [
        {
          name: '水油之恋：液体为什么会分层？',
          time: '8月18日-8月28日每天18:50',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '一秒沸腾的水：平静的水为什么会瞬间沸腾？',
          time: '8月3日-8月13日每天18:50',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '倔强的淀粉糊：遇强则强、遇弱则弱的神奇流体是什么?',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '消失的咖啡勺:金属勺为什么会熔化在咖啡里?',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '徒手劈砖：用手可以轻松劈开的砖头有什么玄机?',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '气球复原术：气球为什么忽而饱满忽而干瘪？',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '许愿神灯与空中楼阁：空空的神灯为何紫气升腾？',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '空中漂浮的小船：小船为什么能悬浮在空空的鱼缸中？',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        }
      ],
    },
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom4.png',
      title: "男孩和女孩如何区别养育",
      intros: "男孩和女孩如何区别养育",
      price: 39,
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay4.mp4',
      controls: true,
      course: '推荐',
      time: '暂无',
      names: '暂无',
      link: 'https://www.xueersi.com/course-detail/83682?m_channel=ad&monitor_type=ad&mevent_id=7395&monitor_id=51189&ad_id=7395'
    },
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom5.png',
      title: "全国版必会题型总结",
      intros: "全国版必会题型总结",
      price: 0,
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay5.mp4',
      controls: true,
      course: '推荐',
      time: '暂无',
      names: '朱涛',
      relateCourse: [

      ],
    }
  ]

}
let videos = {
  hot_recommads: [
    {
      // url: "../assets/hot_eses_banner2x.dark.png",
      url: isProduce ? require("../assets/images/home_recom_gold.png") : 'http://static.eaydu.com/imgs/home/home_recom_relaxed.png',
      name: "励步英语在家上",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_famous_Videos1.mp4',
      controls: true,
    },
    {
      url: isProduce ? require("../assets/images/home_recom_original.png") : 'http://static.eaydu.com/imgs/home/home_recom_gold.png',
      name: "经典120题"
    },
    {
      url: isProduce ? require("../assets/images/home_recom_presentation.png") : 'http://static.eaydu.com/imgs/home/home_recom_original.png',
      name: "家长力学院",
      link: 'https://www.xueersi.com/course-detail/83682?m_channel=ad&monitor_type=ad&mevent_id=7395&monitor_id=51189&ad_id=7395'
    },
    {
      url: isProduce ? require("../assets/images/home_recom_relaxed.png") : 'http://static.eaydu.com/imgs/home/home_recom_presentation.png',
      name: "八大启蒙魔术",
      dataType: 'hot_recommads_side',
      dataindex: 2
    }
  ],
  freeArr: [
    {
      title: "小学英语毕业考提升密训营—必考题型大揭秘",
      time: "4月12日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto1.png',
      names: "荆 楠",
      nums: 1587,
      course: "英语",
      // mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos1.mp4',
      mp4: isProduce ? '' : 'http://static.eaydu.com/vod/GettyImages-905229768.mov',
      controls: true,
      price: 0,
      relateCourse: [
        {
          name: '【暑】六年级升初一英语直播勤学班（全国版）',
          teacher: "荆 楠",
          time: '8月3日-8月13日·每天13:00上课',
          link: 'https://www.xueersi.com/course-detail/78809/561904?switch_grade=-1&switch_subject=3'
        },
        {
          name: '上海小初衔接必修课（英语1期)',
          teacher: "荆 楠",
          time: '5月31日-6月4日每天19:00-20:30',
          link: 'https://www.xueersi.com/course-detail/84348/662510?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【暑】五年级升预初英语直播目标班（沪教版）',
          time: '8月3日-8月13日·每天18:50上课',
          teacher: "荆 楠",
          link: 'https://www.xueersi.com/course-detail/78828/561918?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【暑】六年级升初一英语直播勤学班（全国版）',
          time: '8月18日-8月28日·每天18:50上课',
          teacher: "荆 楠",
          link: 'https://www.xueersi.com/course-detail/78806/561898?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【春下】初二英语直播勤学班（上海沪教）',
          time: '每周六09:00-11:10·6月20日结课',
          teacher: "荆 楠",
          link: 'https://www.xueersi.com/course-detail/73497/352768?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【春下】初二英语直播勤学班（上海沪教）',
          time: '每周六09:00-11:10·6月20日结课',
          teacher: "荆 楠",
          link: 'https://www.xueersi.com/course-detail/73497/352768?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【暑】初二升初三英语直播菁英班（沪教版）',
          time: '8月1日-8月15日·每天09:00上课',
          teacher: "荆 楠",
          link: 'https://www.xueersi.com/course-detail/78819/520983?switch_grade=-1&switch_subject=3'
        },
      ],
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '对英语的热忱,跨越种族和时空',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high1.png'
    },
    {
      title: "妙笔生花-从《茶馆》学人物语言描写",
      time: "4月25日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto2.png',
      names: "齐君颜",
      nums: 1817,
      course: "语文",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos2.mp4',
      controls: true,
      price: 0,

      relateCourse: [
        {
          name: '【暑】六年级升初一语文阅读写作直播班',
          time: '8月18日-8月28日每天18:50',
          teacher: '齐君颜',
          link: 'https://www.xueersi.com/course-detail/79929/562004?switch_grade=-1&switch_subject=1'
        },
        {
          name: '【暑】六年级升初一语文阅读写作直播班',
          time: '8月3日-8月13日每天18:50',
          teacher: '齐君颜',
          link: 'https://www.xueersi.com/course-detail/79938/562022?switch_grade=-1&switch_subject=1'
        },
        {
          name: '【暑】六年级升初一语文阅读写作直播班',
          time: '8月3日-8月13日每天09:00',
          teacher: '齐君颜',
          link: 'https://www.xueersi.com/course-detail/79937/562020?switch_grade=-1&switch_subject=1'
        }
      ],
      upgrade: '四川大学',
      degree: '艺术学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '诗情画意，领略语文之美； <br/> 刷题能手，把握命题方向； <br/>  缜密逻辑，攻克阅读难题； <br/>  发散思维，享受写作乐趣；<br/>',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high2.png'
    },
    {
      title: "一节课突破六年级英语必考易错题",
      time: "4月23日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto3.png',
      names: "林芝卉",
      nums: 742,
      course: "英语",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos3.mp4',
      controls: true,
      price: 0,
      relateCourse: [
        {
          name: '【暑】六年级升初一英语直播目标班（全国版）',
          time: '8月3日-8月13日·每天09:00',
          teacher: '林芝卉',
          link: 'https://www.xueersi.com/course-detail/78858/561946?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【暑】六年级升初一英语直播目标班（全国版）',
          time: '8月3日-8月13日·每天13:00',
          teacher: '林芝卉',
          link: 'https://www.xueersi.com/course-detail/78857/561944?switch_grade=-1&switch_subject=3'
        }
      ],
      upgrade: '知名教育机构项目负责人',
      degree: '优秀培训师，特聘讲师',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '抓住规律，触类旁通；串联知识，事半功倍',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high3.png'
    },
    {
      title: "勤学篇—凿壁借光，闻鸡起舞",
      time: "5月1日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto4.png',
      names: "关 艺",
      nums: 1478,
      course: "语文",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos4.mp4',
      controls: true,
      price: 0,
      relateCourse: [
        {
          name: '【暑】小班数学思维直播班',
          time: '6月29日-9月10日·每周一、周四19:30',
          teacher: '范珈彤',
          link: 'https://www.xueersi.com/course-detail/80130/599059?switch_grade=-1&switch_subject=59'
        },
        {
          name: '【暑】大班语文思维直播班',
          time: '7月1日-9月12日·每周三19:00-19:50',
          teacher: '王 越',
          link: 'https://www.xueersi.com/course-detail/76906/481647?switch_grade=-1&switch_subject=1'
        },
        {
          name: '【目标130+】高三英语暑假一轮复习（上）直播班',
          time: '8月5日-8月17日·每天19:00',
          teacher: '吴俊东',
          link: 'https://www.xueersi.com/course-detail/79320/608013?switch_grade=-1&switch_subject=3'
        },
        {
          name: '【目标省一】高一数学竞赛暑假直播班（一试）',
          time: '7月22日-8月4日·每天12:30',
          teacher: '苏宇坚',
          link: 'https://www.xueersi.com/course-detail/79350/521832?switch_grade=-1&switch_subject=2'
        }
      ],
      upgrade: '南京大学',
      degree: '硕士研究生',
      experience: '10年',
      style: '专注于低年级语文数学',
      idea: '抓住规律，触类旁通；串联知识，事半功倍',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high4.png'
    },
    {
      title: "2019中考数学真题重难点解析",
      time: "5月1日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto5.png',
      names: "文 博",
      nums: 2669,
      course: "数学",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos5.mp4',
      controls: true,
      price: 0,
      relateCourse: [
        {
          name: '【春下目标清北班】高二数学直播班（上海）',
          time: '每周六18:30-20:45·6月20日结课',
          teacher: '文 博',
          link: 'https://www.xueersi.com/course-detail/73054/349329?switch_grade=-1&switch_subject=2'
        },
        {
          name: '【目标双一流】高一数学暑假班（上海)',
          time: '8月5日-8月11日·每天13:30',
          teacher: '文 博',
          link: 'https://www.xueersi.com/course-detail/82619/608867?switch_grade=-1&switch_subject=2'
        },
        {
          name: '【春下目标985班】高二数学直播班（上海）',
          time: '每周日07:30-09:45·6月21日',
          teacher: '文 博',
          link: 'https://www.xueersi.com/course-detail/73056/349369?switch_grade=-1&switch_subject=2'
        },
        {
          name: '【目标140+】高三数学暑假一轮复习（上）直播班（上海）',
          time: '8月5日-8月24日·每天19:00',
          teacher: '文 博',
          link: 'https://www.xueersi.com/course-detail/83059/610905?switch_grade=-1&switch_subject=2'
        },
      ],
      upgrade: '清华大学',
      degree: '美国范德堡大学数学系博士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '高一：思考力——看到什么，想到什么，做了什么；<br/>高二：学习力——学习学习的方法；<br/>高三：专注力与意志力——正确的坚持；<br/>使命：文博留给你的不止是数学，还有人生品格；<br/>',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high5.png'
    },
    {
      title: "中考物理压轴专题—电学篇",
      time: "5月2日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto6.png',
      names: "于鲲鹏",
      nums: 1679,
      course: "物理",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos6.mp4',
      controls: true,
      price: 0,
      relateCourse: [
        {
          name: '【春下目标自招综评班】高一物理直播班',
          time: '每周六15:15-17:30·6月20日结课',
          teacher: '于鲲鹏',
          link: 'https://www.xueersi.com/course-detail/73301/482485?switch_grade=-1&switch_subject=4'
        },
        {
          name: '中考物理实验专题冲刺',
          time: '5月17日-24日每周日',
          teacher: '于鲲鹏',
          link: 'https://www.xueersi.com/course-detail/84189/650962?switch_grade=-1&switch_subject=4'
        },
        {
          name: '【目标强基计划】高二物理暑假直播班',
          time: '8月5日-8月17日·每天10:30',
          teacher: '于鲲鹏',
          link: 'https://www.xueersi.com/course-detail/79363/521875?switch_grade=-1&switch_subject=4'
        },
        {
          name: '【春】高一物理综评习题课——五星学霸养成指南',
          time: '5月16日-6月20日每周六21:00-22:00',
          teacher: '于鲲鹏',
          link: 'https://www.xueersi.com/course-detail/77657/496271?switch_grade=-1&switch_subject=4'
        },
        {
          name: '【春下目标自招综评班】高一物理直播班',
          time: '每周日13:30-15:45·6月21日结课',
          teacher: '于鲲鹏',
          link: 'https://www.xueersi.com/course-detail/73302/351621?switch_grade=-1&switch_subject=4'
        },
        {
          name: '【春下目标自招综评班】高一物理直播班',
          time: '每周六15:15-17:30·6月20日结课',
          teacher: '于鲲鹏',
          link: 'https://www.xueersi.com/course-detail/73301/482485?switch_grade=-1&switch_subject=4'
        }
      ],
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '教师要做的不仅是知识的讲授，更重要的是让学生学会思考，进行真正地学习',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high6.png'
    },
    {
      title: "百强校八年级（下）期中试题选讲",
      time: "5月5日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto7.png',
      names: "刘大权",
      nums: 2319,
      course: "数学",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos7.mp4',
      controls: true,
      price: 0,
      relateCourse: [],
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '教师要做的不仅是知识的讲授，更重要的是让学生学会思考，进行真正地学习',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high7.png'
    },
    {
      title: "北欧神话中的生物",
      time: "5月5日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto8.png',
      names: "周雨凝",
      nums: 1120,
      course: "语文",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos8.mp4',
      controls: true,
      price: 0,
      relateCourse: [],
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '教师要做的不仅是知识的讲授，更重要的是让学生学会思考，进行真正地学习',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high8.png'
    },
    {
      title: "初中一年级培训班（敏学）",
      time: "5月11日",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto9.png',
      names: "王津津",
      nums: 1930,
      course: "英语",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_free_Videos9.mp4',
      controls: true,
      price: 0,
      relateCourse: [],
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '教师要做的不仅是知识的讲授，更重要的是让学生学会思考，进行真正地学习',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_free_teacherPhoto_high9.png'
    }
  ],
  literacyArr: [
    {
      src: isProduce ? require("../assets/images/literacy_eles_banner1.png") : 'http://static.eaydu.com/imgs/home/home_Accom_course1.png',
      title: "讲给孩子的《三字经》",
      sub_titles: "一学就懂的国学经典大师课",
      nums: 5868,
      price: 99,
      names: '钱文忠',
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_Accom_Videos1.mp4',
      controls: true,
      time: '暂无',
      course: '暂无'
    },
    {
      src: isProduce ? require("../assets/images/literacy_eles_banner1.png") : 'http://static.eaydu.com/imgs/home/home_Accom_course2.png',
      title: "3节课读透世界名著",
      sub_titles: "读透老人与海 理解核心硬汉精神",
      nums: 4818,
      price: 39,
      names: '李煜晖',
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_Accom_Videos2.mp4',
      controls: true,
      time: '暂无',
      course: '暂无'
    },
    {
      src: isProduce ? require("../assets/images/literacy_eles_banner1.png") : 'http://static.eaydu.com/imgs/home/home_Accom_course3.png',
      title: "不可不知的大唐盛世",
      sub_titles: "跟随于老师10堂课带孩子全面了解唐朝",
      nums: 2568,
      price: 99,
      names: '于庚哲',
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_Accom_Videos3.mp4',
      controls: true,
      time: '暂无',
      course: '暂无'
    },
    {
      src: isProduce ? require("../assets/images/literacy_eles_banner1.png") : 'http://static.eaydu.com/imgs/home/home_Accom_course4.png',
      title: "诗词可以这样学",
      sub_titles: "跟着诗词逛名胜 变身文化小达人",
      nums: 3571,
      price: 99,
      names: '程遂营',
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_Accom_Videos4.mp4',
      controls: true,
      time: '暂无',
      course: '暂无'
    },
    {
      src: isProduce ? require("../assets/images/literacy_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_Accom_course5.png',
      title: "国家公园里的生物课",
      sub_titles: "国家公园里的生物课",
      nums: 3331,
      price: 39,
      names: '冯利民',
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_Accom_Videos5.mp4',
      controls: true,
      time: '暂无',
      course: '暂无'
    },
    {
      src: isProduce ? require("../assets/images/literacy_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_Accom_course6.png',
      title: "沈石溪的作文技巧课",
      sub_titles: "5招写出好作文",
      nums: 1695,
      price: 59,
      names: '沈石溪',
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_Accom_Videos6.mp4',
      controls: true,
      time: '暂无',
      course: '暂无'
    },
    {
      src: isProduce ? require("../assets/images/literacy_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_Accom_course7.png',
      title: "李天飞精讲《三国演义》",
      sub_titles: "一学就通的名著阅读法",
      nums: 581,
      price: 99,
      names: '李天飞',
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_Accom_Videos7.mp4',
      controls: true,
      time: '暂无',
      course: '暂无'
    },
    {
      src: isProduce ? require("../assets/images/literacy_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_Accom_course8.png',
      title: "理科思维记古诗",
      sub_titles: "中国诗词大会冠军陈更独家开讲",
      nums: 2581,
      price: 39,
      names: '陈更',
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_Accom_Videos8.mp4',
      controls: true,
      time: '暂无',
      course: '暂无'
    }
  ],
  famous_good: [
    {
      url: isProduce ? require("../assets/images/teacher-second.png") : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher1.png',
      baseinfo: "尹辰（Eason）",
      intro:
        "6年教龄, 总结了一套系统的教学体系，对国内中考和MSE有深入研究课堂气氛活跃，让孩子摆脱沉闷的传统教学方式",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_famous_Videos1.mp4',
      controls: true,
      names: '尹辰（Eason）',
      time: '暂无',
      title: '暂无',
      price: 0,
      course: '暂无',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher_hight1.png',
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '对英语的热忱,跨越种族和时空',
    },
    {
      url: isProduce ? require("../assets/images/teacher-second.png") : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher2.png',
      baseinfo: "杨萌",
      intro:
        "7年教龄，高级教师，网校著名激情派老师学而思网校物理产品负责人初中物理课程体系设计者",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_famous_Videos2.mp4',
      controls: true,
      names: '杨萌',
      time: '暂无',
      title: '暂无',
      price: 0,
      course: '暂无',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher_hight2.png',
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '对英语的热忱,跨越种族和时空',
    },
    {
      url: isProduce ? require("../assets/images/teacher-second.png") : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher3.png',
      baseinfo: "刘飞飞",
      intro:
        "19年教龄，北大毕业语言怪才，大师授课，好评如潮",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_famous_Videos3.mp4',
      controls: true,
      names: '刘飞飞',
      time: '暂无',
      title: '暂无',
      price: 0,
      course: '暂无',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher_hight3.png',
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '对英语的热忱,跨越种族和时空',
      isjump: true,
      link: 'https://www.xueersi.com/t/liufeifei'
    },
    {
      url: isProduce ? require("../assets/images/teacher-second.png") : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher4.png',
      baseinfo: "杨晓雅（Miya）",
      intro:
        "学而思全国金牌教师，S级教师，感染力强，标准地道活泼的语音语调和丰富的姿体动作，引导每一个孩子参与到课堂中",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_famous_Videos4.mp4',
      controls: true,
      names: '杨晓雅（Miya)',
      time: '暂无',
      title: '暂无',
      price: 0,
      course: '暂无',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher_hight4.png',
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '对英语的热忱,跨越种族和时空',
    },
    {
      url: isProduce ? require("../assets/images/teacher-second.png") : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher5.png',
      baseinfo: "朱滔（滔哥）",
      intro:
        "教龄17年，学而思网校优秀教师，中考专家",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_famous_Videos5.mp4',
      controls: true,
      names: '朱滔（滔哥)',
      time: '暂无',
      title: '暂无',
      price: 0,
      course: '暂无',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher_hight5.png',
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '对英语的热忱,跨越种族和时空',
    },
    {
      url: isProduce ? require("../assets/images/teacher-second.png") : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher6.png',
      baseinfo: "周雨凝（嘻嘻）",
      intro:
        "深谙儿童心理及教学法，所教的学生，不仅语文成绩达到大幅度的提高，更重要的是提升了对语文的学习兴趣",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_famous_Videos6.mp4',
      controls: true,
      names: '周雨凝（嘻嘻)',
      time: '暂无',
      title: '暂无',
      price: 0,
      course: '暂无',
      highSrc: isProduce ? '' : 'http://static.eaydu.com/imgs/videos/videos_famous_teacher_hight6.png',
      upgrade: '英国布里斯托大学',
      degree: '教育学硕士',
      experience: '10年',
      style: '口语美国外教标准',
      idea: '对英语的热忱,跨越种族和时空',
    }
  ],
  hot_recommads_side: [
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom1.png',
      title: "如何把物理变成你的优势学科",
      intros: "如何把物理变成你的优势学科",
      price: 0,
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay1.mp4',
      controls: true,
      course: '推荐',
      time: '暂无',
      names: '杨萌'
    },
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom2.png',
      title: "茶馆，东方舞台上的奇迹",
      intros: "茶馆，东方舞台上的奇迹",
      price: 0,
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay2.mp4',
      controls: true,
      course: '推荐',
      time: '暂无',
      names: '齐君颜',
      relateCourse: [
        {
          name: '【暑】六年级升初一语文阅读写作直播班',
          time: '8月18日-8月28日每天18:50',
          teacher: '齐君颜',
          link: 'https://www.xueersi.com/course-detail/79929/562004?switch_grade=-1&switch_subject=1'
        },
        {
          name: '【暑】六年级升初一语文阅读写作直播班',
          time: '8月3日-8月13日每天18:50',
          teacher: '齐君颜',
          link: 'https://www.xueersi.com/course-detail/79938/562022?switch_grade=-1&switch_subject=1'
        },
        {
          name: '【暑】六年级升初一语文阅读写作直播班',
          time: '8月3日-8月13日每天09:00',
          teacher: '齐君颜',
          link: 'https://www.xueersi.com/course-detail/79937/562020?switch_grade=-1&switch_subject=1'
        }
      ],
    },
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom3.png',
      title: "如何把物理变成你的优势学科",
      intros: "如何把物理变成你的优势学科",
      price: 0,
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay3.mp4',
      controls: true,
      course: '推荐',
      time: '8月18日',
      names: '段超',
      relateCourse: [
        {
          name: '水油之恋：液体为什么会分层？',
          time: '8月18日-8月28日每天18:50',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '一秒沸腾的水：平静的水为什么会瞬间沸腾？',
          time: '8月3日-8月13日每天18:50',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '倔强的淀粉糊：遇强则强、遇弱则弱的神奇流体是什么?',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '消失的咖啡勺:金属勺为什么会熔化在咖啡里?',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '徒手劈砖：用手可以轻松劈开的砖头有什么玄机?',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '气球复原术：气球为什么忽而饱满忽而干瘪？',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '许愿神灯与空中楼阁：空空的神灯为何紫气升腾？',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '空中漂浮的小船：小船为什么能悬浮在空空的鱼缸中？',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        }
      ],
    },
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom4.png',
      title: "男孩和女孩如何区别养育",
      intros: "男孩和女孩如何区别养育",
      price: 39,
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay4.mp4',
      controls: true,
      course: '推荐',
      time: '暂无',
      names: '暂无',
      link: 'https://www.xueersi.com/course-detail/83682?m_channel=ad&monitor_type=ad&mevent_id=7395&monitor_id=51189&ad_id=7395'
    },
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom5.png',
      title: "全国版必会题型总结",
      intros: "全国版必会题型总结",
      price: 0,
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay5.mp4',
      controls: true,
      course: '推荐',
      time: '暂无',
      names: '朱涛',
      relateCourse: [
        {
          name: '水油之恋：液体为什么会分层？',
          time: '8月18日-8月28日每天18:50',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '一秒沸腾的水：平静的水为什么会瞬间沸腾？',
          time: '8月3日-8月13日每天18:50',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '倔强的淀粉糊：遇强则强、遇弱则弱的神奇流体是什么?',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '消失的咖啡勺:金属勺为什么会熔化在咖啡里?',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '徒手劈砖：用手可以轻松劈开的砖头有什么玄机?',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '气球复原术：气球为什么忽而饱满忽而干瘪？',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '许愿神灯与空中楼阁：空空的神灯为何紫气升腾？',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        },
        {
          name: '空中漂浮的小船：小船为什么能悬浮在空空的鱼缸中？',
          time: '8月3日-8月13日每天09:00',
          teacher: '段超',
          link: 'https://www.xueersi.com/course-detail/84528/0?switch_grade=-1&switch_subject=-1'
        }
      ],
    }
  ]
};

let download = {
  downLoadArr: [
    {
      src: isProduce ? require("../assets/images/icons.jpg") : 'http://static.eaydu.com/imgs/download/download_course_icon1.png',
      title: "学而思云学习",
      introduce: "",
      sub_introduce: ""
    },
    {
      src: isProduce ? require("../assets/images/icons.jpg") : 'http://static.eaydu.com/imgs/download/download_course_icon2.png',
      title: "学而思培优",
      introduce: "",
      sub_introduce: ""
    },
    {
      src: isProduce ? require("../assets/images/icons.jpg") : 'http://static.eaydu.com/imgs/download/download_course_icon3.png',
      title: "学而思网校",
      introduce: "",
      sub_introduce: ""
    },
    {
      src: isProduce ? require("../assets/images/icons.jpg") : 'http://static.eaydu.com/imgs/download/download_course_icon4.png',
      title: "励步启蒙",
      introduce: "",
      sub_introduce: ""
    },
    {
      src: isProduce ? require("../assets/images/icons.jpg") : 'http://static.eaydu.com/imgs/download/download_course_icon5.png',
      title: "爱智康",
      introduce: "",
      sub_introduce: ""
    },
    {
      src: isProduce ? require("../assets/images/icons.jpg") : 'http://static.eaydu.com/imgs/download/download_course_icon6.png',
      title: "小猴英语",
      introduce: "",
      sub_introduce: ""
    },
    {
      src: isProduce ? require("../assets/images/icons.jpg") : 'http://static.eaydu.com/imgs/download/download_course_icon7.png',
      title: "学而思口算",
      introduce: "",
      sub_introduce: ""
    },
    {
      src: isProduce ? require("../assets/images/icons.jpg") : 'http://static.eaydu.com/imgs/download/download_course_icon8.png',
      title: "摩比思维",
      introduce: "",
      sub_introduce: ""
    },
    {
      src: isProduce ? require("../assets/images/icons.jpg") : 'http://static.eaydu.com/imgs/download/download_course_icon9.png',
      title: "励步英语",
      introduce: "",
      sub_introduce: ""
    }
  ]
}
let more = {
  moreList: [
    {
      title: "超有趣的数学思维启蒙直播课",
      course: "数学",
      intro: "3月18日-3月10日·七年级 | 范老师",
      time: "3月18日"
    },
    {
      title: "超有趣的数学思维启蒙直播课",
      course: "数学",
      intro: "3月18日-3月10日·七年级 | 范老师",
      time: "3月18日"
    },
    {
      title: "超有趣的数学思维启蒙直播课",
      course: "数学",
      intro: "3月18日-3月10日·七年级 | 范老师",
      time: "3月18日"
    },
    {
      title: "超有趣的数学思维启蒙直播课",
      course: "数学",
      intro: "3月18日-3月10日·七年级 | 范老师",
      time: "3月18日"
    },
    {
      title: "超有趣的数学思维启蒙直播课",
      course: "数学",
      intro: "3月18日-3月10日·七年级 | 范老师",
      time: "3月18日"
    },
    {
      title: "超有趣的数学思维启蒙直播课",
      course: "数学",
      intro: "3月18日-3月10日·七年级 | 范老师",
      time: "3月18日"
    },
    {
      title: "超有趣的数学思维启蒙直播课",
      course: "数学",
      intro: "3月18日-3月10日·七年级 | 范老师",
      time: "3月18日"
    },
    {
      title: "超有趣的数学思维启蒙直播课",
      course: "数学",
      intro: "3月18日-3月10日·七年级 | 范老师",
      time: "3月18日"
    },
    {
      title: "超有趣的数学思维启蒙直播课",
      course: "数学",
      intro: "3月18日-3月10日·七年级 | 范老师",
      time: "3月18日"
    },
    {
      title: "超有趣的数学思维启蒙直播课",
      course: "数学",
      intro: "3月18日-3月10日·七年级 | 范老师",
      time: "3月18日"
    }
  ]
}
let watch = {
  hot_recommand: [
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom1.png',
      title: "物理名师精品课",
      intros: "如何把物理变成你的优势学科",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay1.mp4',
      controls: true
    },
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom2.png',
      title: "语文鉴赏课",
      intros: "茶馆，东方舞台上的奇迹",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay2.mp4',
      controls: true
    },
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom3.png',
      title: "玩魔术学物理",
      intros: "零基础八大启蒙魔术，在家就能做",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay3.mp4',
      controls: true
    },
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom4.png',
      title: "樊登—家长力学院",
      intros: "男孩和女孩如何区别养育",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay4.mp4',
      controls: true,
      link: 'https://www.xueersi.com/course-detail/83682?m_channel=ad&monitor_type=ad&mevent_id=7395&monitor_id=51189&ad_id=7395'
    },
    {
      images: isProduce ? require("../assets/images/hot_eles_banner1.png") : 'http://static.eaydu.com/imgs/videos/videos_side_recom5.png',
      title: "滔哥带你探究数学规律",
      intros: "全国版必会题型总结",
      mp4: isProduce ? '' : 'http://static.eaydu.com/mp4/videos/videos_toPlay5.mp4',
      controls: true
    }
  ],
  videos: {
    path:
      isProduce ? "http://vali.cp31.ott.cibntv.net/youku/697470586784871dd4da1632a/03000801005E7C4D217E7E7003E88018D6EB09-B02A-4258-8D1F-08D2F2F3F6BF.mp4?sid=158605580900010001556_00_B74579faf82176d5d0b262fdd5077aebe&sign=662aef43ba720e0c596ae220cdd5b868&ctype=50" : 'http://static.eaydu.com/mp4/videos/videos_toPlay1.transverse.mp4',
    controls: true
  },
  src: isProduce ? "https://dss0.bdstatic.com/5aV1bjqh_Q23odCf/static/superman/img/topnav/baiduyun@2x-e0be79e69e.png" : 'http://static.eaydu.com/imgs/videos/videos_teacher_intro.png',
  star: {
    rating: isProduce ? 3 : 0,
    staticRating: isProduce ? 4.6 : 0,
    value: isProduce ? 3 : 0
  },
  freeArr: [
    {
      title: "超有趣的数学思维启蒙直播课",
      time: "3月18日-3月10日·七年级",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/home/home_free_teacherPhoto1.png',
      names: "范老师",
      nums: 8888,
      course: "英语"
    },
    {
      title: "超有趣的数学思维启蒙直播课",
      time: "3月18日-3月10日·七年级",
      src: isProduce ? '' : 'http://static.eaydu.com/imgs/home/home_free_teacherPhoto2.png',
      names: "范老师",
      nums: 8689,
      course: "英语"
    }],

}

let footer = {
  footerArr: [
    {
      src: isProduce ? require("../assets/images/example1.png") : 'http://static.eaydu.com/imgs/download/download_course_icon1.png',
      name: "学而思云学习"
    },
    {
      src: isProduce ? require("../assets/images/example1.png") : 'http://static.eaydu.com/imgs/download/download_course_icon2.png',
      name: "学而思培优"
    },
    {
      src: isProduce ? require("../assets/images/example1.png") : 'http://static.eaydu.com/imgs/download/download_course_icon3.png',
      name: "学而思网校"
    },
    {
      src: isProduce ? require("../assets/images/example1.png") : 'http://static.eaydu.com/imgs/download/download_course_icon4.png',
      name: "励步启蒙"
    },
    // {
    //   src: isProduce ? require("../assets/images/example1.png") : 'http://static.eaydu.com/imgs/footer/footer_course_icon5.png',
    //   name: "爱智康"
    // },
    {
      src: isProduce ? require("../assets/images/example1.png") : 'http://static.eaydu.com/imgs/download/download_course_icon6.png',
      name: "小猴英语"
    },
    {
      src: isProduce ? require("../assets/images/example1.png") : 'http://static.eaydu.com/imgs/download/download_course_icon7.png',
      name: "学而思口算"
    },
    {
      src: isProduce ? require("../assets/images/example1.png") : 'http://static.eaydu.com/imgs/download/download_course_icon8.png',
      name: "摩比思维"
    },
    {
      src: isProduce ? require("../assets/images/example1.png") : 'http://static.eaydu.com/imgs/download/download_course_icon9.png',
      name: "励步英语"
    }
  ],
  footerQR: [
    {
      src: isProduce ? require("../assets/images/example1.png") : 'http://static.eaydu.com/imgs/footer/footer_QR_code1.png',
    },
    // {
    //   src: isProduce ? require("../assets/images/example1.png") : 'http://static.eaydu.com/imgs/footer/footer_QR_code2.png',
    // }
  ]
}

let secondWatch = {
  introImg: [
    {
      imgUrl: isProduce ? require('../assets/images/banner_bg.png') : 'http://static.eaydu.com/imgs/secondWatch/secondWatch_recommand_background.png'
    },
    {
      imgUrl: isProduce ? require('../assets/images/banner_bg.png') : 'http://static.eaydu.com/imgs/secondWat/secondWatch_recommand_background1.png'
    },
    {
      imgUrl: isProduce ? require('../assets/images/banner_bg.png') : 'http://static.eaydu.com/imgs/secondWat/secondWatch_recommand_background2.png'
    },
    {
      imgUrl: isProduce ? require('../assets/images/banner_bg.png') : 'http://static.eaydu.com/imgs/secondWat/secondWatch_recommand_background3.png'
    },
    {
      imgUrl: isProduce ? require('../assets/images/banner_bg.png') : 'http://static.eaydu.com/imgs/secondWat/secondWatch_recommand_background4.png'
    },
    {
      imgUrl: isProduce ? require('../assets/images/banner_bg.png') : 'http://static.eaydu.com/imgs/secondWat/secondWatch_recommand_background5.png'
    },
    {
      imgUrl: isProduce ? require('../assets/images/banner_bg.png') : 'http://static.eaydu.com/imgs/secondWat/secondWatch_recommand_background6.png'
    },
    {
      imgUrl: isProduce ? require('../assets/images/banner_bg.png') : 'http://static.eaydu.com/imgs/secondWat/secondWatch_recommand_background7.png'
    },
    {
      imgUrl: isProduce ? require('../assets/images/banner_bg.png') : 'http://static.eaydu.com/imgs/secondWat/secondWatch_recommand_background8.png'
    },
    {
      imgUrl: isProduce ? require('../assets/images/banner_bg.png') : 'http://static.eaydu.com/imgs/secondWat/secondWatch_recommand_background9.png'
    },
  ]

}
export {
  home,
  videos,
  download,
  more,
  watch,
  footer,
  secondWatch
}